import React from 'react'
import EshopCategory from './EshopCategory'

const EshopTresGrand = ({ products = [], eshopInfo = null }) => (
    <EshopCategory products={products} category="très grand" eshopInfo={eshopInfo} />
)

export default EshopTresGrand